document.addEventListener('DOMContentLoaded', () => {
    const fileInputs = document.querySelectorAll('.file-input');

    if (fileInputs.length > 0) {
        fileInputs.forEach(input => {
            input.onchange = () => {
                if (input.files.length > 0) {
                    const fileName = input.parentNode.querySelector('.file-name');
                    fileName.textContent = input.files[0].name;
                }
            }
        });
    }
});